import React, { useState, useEffect } from "react";
import useDebounce from "../../../hooks/useDebounce";
import "./style.scss";
import { allowEverything } from "../../../utils";

interface Props {
  regexCheck?: (value: string)=> string;
  inputType?: string;
  onSerachInput?: any; // it will a function which will be triggered on debounce action
  searchMinLength?: number; // minimum length on which we will trigger the search function
  placeholder: string;
  customClass?: string;
  elementWidthClass?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  debounceDuration?: number;
  onClear?: any;
  isParentControlled?: boolean;
  parentControlledValue?: string;
  parentControlledOnchange?: any;
}

const SearchInputComponent = (props: Props) => {
  const { regexCheck = allowEverything, onSerachInput, placeholder, customClass = "", elementWidthClass = "", autoFocus = false, parentControlledValue = "", isParentControlled, parentControlledOnchange, inputType = 'text' } = props;
  const [searchValue, setSearchInput] = useState<string>("");
  const debouncedSearchTerm: string = useDebounce<string>(searchValue, props.debounceDuration || 500);

  useEffect(() => {
    onSerachInput?.(searchValue);
  },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  return (
    <div className={`flex relative ${elementWidthClass}`}>
      { !searchValue? <div className="rista-sprite ic-search-grey scale-75 z-1 absolute left-8 top-[50%] translate-y-[-50%]"></div>: null}
      <input
        type={props.inputType} // added default value
        onChange={(e) => {
          e.stopPropagation();
          e.preventDefault();
          if (isParentControlled) {
            parentControlledOnchange(regexCheck(e.target.value));
          } else {
            setSearchInput(regexCheck(e.target.value));
          }
        }}
        className={`${customClass} relative search-input-box w-[100%] ${props.disabled ? "bg-greyFAFAFA" : "bg-white"} font-regular py-8 pr-24 ${searchValue? 'pl-[24px]': 'pl-[32px]'} rounded-[8px] border-[1px] border-greyEB`}
        placeholder={placeholder}
        value={isParentControlled ? parentControlledValue : searchValue}
        autoFocus={autoFocus}
        >
      </input>
      {searchValue || parentControlledValue ? <span className="absolute right-12 top-[50%] translate-y-[-50%] scale-[0.60] cursor-pointer rista-sprite ic-cross-black" onClick={() => { setSearchInput(""); onSerachInput?.(""); props.onClear?.()}}></span> : null}
    </div>
  )
};

export default SearchInputComponent;